<template>
    <div class="block-editor youtube-reply-comment">
        <section>
            <div class="title">{{ $t('auto.youTubeReplyCommentChannelId') }}</div>
            <TiptapEditor placeholder="YouTube Channel ID" :show-attributes="true" v-model="clone.channelId" automation-mode />
            <small>{{ $t('auto.youTubeReplyCommentYanTVerilecekYorumunBulunduUKanalIdsi') }}</small>
        </section>
        <section>
            <div class="title">{{ $t('auto.youTubeReplyCommentCommentId') }}</div>
            <TiptapEditor placeholder="YouTube Comment ID" :show-attributes="true" v-model="clone.commentId" automation-mode />
            <small>{{ $t('auto.youTubeReplyCommentYanTVerilecekYorumunIdsi') }}</small>
        </section>
        <section>
            <div class="title">{{ $t('auto.youTubeReplyCommentYanTMetni') }}</div>
            <TiptapEditor placeholder="Yanıt metni giriniz..." :show-attributes="true" v-model="clone.text" automation-mode />
        </section>
    </div>
</template>

<script>
import _ from "lodash";
import TiptapEditor from "../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
export default {
    name: "YouTubeReplyComment",
    components: {
        TiptapEditor,
    },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep({
                channelId: "",
                commentId: "",
                text: "",
                ...this.value
            }),
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.youtube-reply-comment {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    section {
        margin-bottom: 20px;
    }

    .title {
        font-weight: bold;
        margin-bottom: 5px;
    }

    small {
        color: #777;
    }
}
</style>
